import t from "@ext/localization/locale/translate";
import { useViewSurfaceVariant } from "@ext/markdown/elements/view/models/ViewSurfaceVariant";
import ViewEmptyState from "@ext/markdown/elements/view/render/components/ViewEmptyState";
import getCountArticles from "@ext/markdown/elements/view/render/logic/getCountArticles";
import type { PropertyValue, ViewRenderGroup } from "@ext/properties/models";
import { Display } from "@ext/properties/models/display";
import { getDisplayComponent } from "@ext/properties/models/displays";
import { memo } from "react";

interface ViewRenderContentProps {
	content: ViewRenderGroup[];
	display: Display;
	defs: PropertyValue[];
	orderby: PropertyValue[];
	groupby: string[];
	select: string[];
	className?: string;
	disabled: boolean;
	commentId?: string;
	isPrint?: boolean;
	updateArticle?: (
		articlePath: string,
		property: string,
		value: string,
		isDelete?: boolean,
		moveFrom?: string | null,
	) => void;
}

const ViewRenderContent = memo(
	({ content, className, display, updateArticle, commentId, isPrint, ...otherProps }: ViewRenderContentProps) => {
		const surface = useViewSurfaceVariant();
		const count = getCountArticles(content);

		if (!count)
			return (
				<ViewEmptyState
					description={t("properties.view.empty-state.no-content.description")}
					icon="file-search"
					title={t("properties.view.empty-state.no-content.title")}
				/>
			);

		const Component = getDisplayComponent(isPrint ? Display.List : display, surface);

		return (
			<div data-component="view">
				<Component
					{...otherProps}
					className={className}
					commentId={commentId}
					content={content}
					isPrint={isPrint}
					updateArticle={updateArticle}
				/>
			</div>
		);
	},
);

export default ViewRenderContent;
